import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../providers/auth_provider';
import { Editor } from '@tinymce/tinymce-react';

export default function EditTemplate({ fetchTemplates, template }) {
    const { token } = useAuth();
    const [formData, setFormData] = useState({
        template_name: template?.template_name || '',
        message: template?.message || '<img src="https://admin.enervybe.net/assets/img/logo.png" />',
        title: template?.title || '',
        user_accessible: template?.user_accessible || false
    });

    // Update formData when template prop changes
    useEffect(() => {
        if (template) {
            setFormData({
                template_name: template.template_name || '',
                message: template.message || '',
                user_accessible: template.user_accessible || false,
                title: template.title || '',
            });
        }
    }, [template]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Handle rich text editor changes separately
    const handleEditorChange = (content) => {
        setFormData(prev => ({
            ...prev,
            message: content
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/template/${template?.id}`,
                formData,
                {
                    headers: {
                        Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            fetchTemplates();
            toast.success('Template updated successfully!');
            document.getElementById('closeModal').click();
            document.getElementById('closeCanvas').click();
        } catch (error) {
            console.error('Error updating template:', error);
            toast.error(error?.response?.data?.message || 'An error occurred while updating the template');
        }
    };


    const editorConfig = {
        height: 400,
        menubar: true,
        plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'help', 'wordcount'
        ],
        toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | table | help',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
    };


    return (
        <div
            className="offcanvas offcanvas-end width-50"
            tabIndex={-1}
            id="editTemplate"
            aria-labelledby="offcanvasAddTemplateLabel"
        >
            <div className="offcanvas-header border-bottom">
                <h5 id="offcanvasAddTemplateLabel" className="offcanvas-title">
                    Edit Template
                </h5>
                <button
                    id="closeCanvas"
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                />
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 h-100">
                <div className="alert alert-warning alert-dismissible" role="alert">
                    <h5 className="alert-heading mb-6">Important: Variable Changes</h5>
                    <span>
                        Changing any variable written in this <strong>{"{{}}"}</strong> can cause working issues.
                    </span>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                    />
                </div>
                <form
                    className="add-new-template pt-0"
                    id="addNewTemplateForm"
                    onSubmit={handleSubmit}
                >
                    {/* Template Name */}
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            id="template-name"
                            placeholder="Enter template name"
                            name="template_name"
                            value={formData.template_name}
                            onChange={handleInputChange}
                            aria-label="Template Name"
                        />
                        <label htmlFor="template-name">Template Name</label>
                    </div>

                    {/* Title */}
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            id="template-title"
                            placeholder="Enter subject"
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            aria-label="Subject"
                        />
                        <label htmlFor="template-title">Subject</label>
                    </div>

                    {/* User Accessible */}
                    <div className="form-check my-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="user-accessible"
                            name="user_accessible"
                            checked={formData.user_accessible}
                            onChange={handleInputChange}
                        />
                        <label className="form-check-label" htmlFor="user-accessible">
                            Affiliate Accessible
                        </label>
                    </div>

                    {/* Rich Text Editor */}
                    <div className="mb-3">
                        <label className="form-label">Message</label>
                        <Editor
                            apiKey='9rfldgcdc9dmma091ep27vm5qlyb0n4qgm80qm8kelo9s860'
                            value={formData.message}
                            onEditorChange={handleEditorChange}
                            init={editorConfig}
                        />
                    </div>

                    <hr />
                    <button
                        type="submit"
                        className="btn btn-success me-sm-3 me-1 data-submit mt-5"
                    >
                        Submit
                    </button>
                    <button
                        id="closeModal"
                        type="reset"
                        className="btn btn-outline-secondary mt-5"
                        data-bs-dismiss="offcanvas"
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    );
}